<template>
    <div class="link-banner-section">
        <div class="container">
            <div class="link-banner-content">
                <div class="link-banner-left">
                    <div class="link-banner-logos">
                        <img v-lazy="$ossImg('icon/logo_white.png')"
                            alt="YOGEE"
                            class="link-banner-logo"
                        />
                        <img v-lazy="$ossImg('icon/and.png')"
                            alt="JOMEC"
                            class="link-banner-logo-and"
                        />
                        <img v-lazy="$ossImg('icon/jomec_white.png')"
                            alt="JOMEC"
                            class="link-banner-logo"
                        />
                    </div>
                    <p class="link-banner-text">
                        {{ $t('home.linkBanner.text') }}
                    </p>
                </div>
                <div class="link-banner-right">
                    <a
                        class="link-banner-button"
                        href="http://jomec-auto.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span class="link-banner-button-text">{{ $t('home.linkBanner.button') }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LinkBanner',
    computed: {
        linkBannerBackground() {
            return `url(${this.$ossImg('banner/link.jpg')})`
        }
    }
}
</script>

<style scoped>
.link-banner-section {
    background-image: v-bind('linkBannerBackground');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 55px 0;
}

.link-banner-content {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}

.link-banner-left {
    flex: 1 1 auto;
    min-width: 0;
}

.link-banner-logos {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 36px;
    margin-top: 16px;
    margin-bottom: 21px;
}

.link-banner-logo {
    max-height: 28px;
    width: auto;
}
.link-banner-logo-and {
    width: 16px;
    margin-top: 2px;
}
.link-banner-separator {
    color: #F6FAFF;
    font-size: 36.848px;
    font-style: normal;
    font-weight: 300;
    line-height: 156%;
}

.link-banner-text {
    margin-top: 9px;
    margin-bottom: 0;
    color: #f6faff;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 156%;
    word-break: break-word;
}

.link-banner-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 24px;
}

.link-banner-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 14px 79px;
    border-radius: 999px;
    background-color: #ffffff;
    text-decoration: none;
    border: none;
    box-shadow: 0 4px 16px rgba(11, 113, 250, 0.15);
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.link-banner-button-text {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    transition: color 0.3s ease;
}

.link-banner-button:hover {
    text-decoration: none;
    box-shadow: 0 6px 20px rgba(11, 113, 250, 0.25);
}

.link-banner-button:hover .link-banner-button-text {
    color: #0b71fa;
}

@media (max-width: 991px) {
    .link-banner-content {
        flex-direction: column;
        align-items: flex-start;
    }

    .link-banner-right {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
        justify-content: flex-start;
    }
}

@media (max-width: 575px) {
    .link-banner-section {
        padding: 55px 0;
    }

    .link-banner-text {
        font-size: 16px;
        line-height: 1.5;
    }

    .link-banner-right {
        justify-content: center;
    }
}
</style>
